import React from 'react';
const MaskUser = () => {
    return (
        <div className="dashboard-image">
            <div className="card text-center p-4">
                <div className="card-body">
                    <h5 className="card-title" style={{fontSize: '16px'}}>Become a Beta User</h5>
                    <p className="card-text">Get access to our latest updates</p>
                    <a className="btn btn-warning">Join</a>
                </div>
            </div>
        </div>
    );
};

export default MaskUser;
